<template>
  <h-frame type="left">
    <div class="eventAnalysisLeft">
      <div class="itemDetail">
        <x-title>
          <div class="titleWidth">
            处理状态
            <!-- <div class="titleMore">更多</div> -->
          </div>
        </x-title>
        <eventLeftOne></eventLeftOne>
      </div>
      <div class="itemDetail">
        <x-title>
          <div class="titleWidth">
            响应时间
            <!-- <div class="titleMore">更多</div> -->
          </div>
        </x-title>
        <eventLeftTwo></eventLeftTwo>
      </div>
      <div class="itemDetail">
        <x-title>
          <div class="titleWidth">
            事件类型TOP5
            <!-- <div class="titleMore">更多</div> -->
          </div>
        </x-title>
        <eventLeftThree class="echartsthree"></eventLeftThree>
      </div>
    </div>
  </h-frame>
</template>
<script>
import { defineComponent, reactive, toRefs } from "vue";
// import * as echarts from "echarts";
import eventLeftOne from "./eventLeftOne";
import eventLeftTwo from "./eventLeftTwo";
import eventLeftThree from "./eventLeftThree";
// import threeechartsone from "./threeechartsone";
import { prisonHouseHoldType } from "@/api/threeSolid/threeSolidHome.js";

export default defineComponent({
  name: "",
  components: {
    eventLeftOne,
    eventLeftTwo,
    eventLeftThree
  },
  props: {},
  setup(props) {
    const data = reactive({
      leftList: [
        { name: "人口", value: "123", icon: "icon-tianjia1", id: "1" },
        { name: "房屋", value: "25", icon: "icon-tianjia1", id: "2" },
        { name: "单位", value: "47", icon: "icon-tianjia1", id: "3" },
        { name: "警情事件", value: "523", icon: "icon-tianjia1", id: "4" },
        { name: "安防设施", value: "12", icon: "icon-tianjia1", id: "5" },
        { name: "力量装备", value: "32", icon: "icon-tianjia1", id: "6" }
      ]
    });
    const refData = toRefs(data);
    const numberall = async () => {
      const res = await prisonHouseHoldType();
      console.log("numberall ~ res", res);
    };
    numberall();
    // echarts

    return { ...refData };
  }
});
</script>
<style lang="scss" scoped>
.eventAnalysisLeft {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  padding-top: 15px;
  overflow: auto;
  color: white;
  .itemDetail {
    height: 33%;
  }
  .titleWidth {
    width: 100%;
  }
  //
  .titleMore {
    float: right;
    cursor: pointer;
    // margin-right: 15px;
    background: #5189b4;
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 14px;
  }
  #echartsthree {
    height: 220px;
  }
  #echartsbottomLeft {
    width: 400px;
    height: 220px;
  }
}
</style>
